import React, { Component } from "react";
import PropTypes from "prop-types";
import List from "@material-ui/core/List";
import axios, { taxServiceClient } from "../../AxiosClient";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation, initReactI18next } from "react-i18next";
import Pagination from "@material-ui/lab/Pagination";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import { IconButton } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import FilterListIcon from "@material-ui/icons/FilterList";
import FilterWrapper from "../../components/filter/FilterWrapper";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

const styles = (theme) => ({
  textField: {
    margin: theme.spacing(1),
    "& input ": {
      margin: theme.spacing(1),
    },
  },
  container: {
    width: "100%",
  },
  toggleContainer: {
    marginTop: theme.spacing(2),
  },
  pgContainer: {
    display: "flex",
  },
  paginator: {
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
  },
  avatar: {
    minWidth: "34px",
  },
  primaryInfoDiv: {
    display: "flex",
    width: "100%",
  },
  editIconDiv: {
    marginLeft: theme.spacing(2),
    float: "right",
  },
  titleDiv: {
    width: "100%",
  },
  toolBar: {
    textAlign: "center",
  },
  tooltip: { zIndex: 10003 },
});
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class FilterableList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      filter: "",
      page: 1,
      pageSize: this.props.pageSize ? this.props.pageSize : 5,
      pages: 0,
      sort: "ASC",
      sortDescSVG: "M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z",
      sortAscSVG: "M3 11H15V13H3M3 18V16H21V18M3 6H9V8H3Z",
      filters: {},
      showFilters: false,
      filterInstance: new Date(),
      filterTitle: "",
      anchorEl: null,
      asPopper: false,
      selectedItem: null,
      expanded: [],
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }
  componentDidMount() {
    this.getData();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.organization) {
      if (prevProps.organization) {
        if (
          this.props.organization.organizationId !==
            prevProps.organization.organizationId &&
          this.props.dataurl !== "/organization/"
        ) {
          this.getData();
        }
      } else {
        this.getData();
      }
      if (this.props.needsUpdate === true) {
        this.getData();
      }
    }
  }
  onFilterChange = (filter) => {
    this.setState(
      {
        filters: filter,
      },
      () => {
        this.getData();
      }
    );
  };
  showFilters = (e) => {
    this.state.asPopper
      ? this.setState({ showFilters: true, anchorEl: e.target })
      : this.setState((prev) => ({
          showFilters: !prev.showFilters,
          anchorEl: e.target,
        }));
  };
  hideFilters = () => {
    this.setState({ showFilters: false });
  };
  resetToDefaultFilters = (defaultFilter) => {
    this.setState({ filters: defaultFilter }, () => {
      this.getData();
    });
  };
  showFilterReset = (defaultFilter) => {
    return Object.keys(this.state.filters).length === 0
      ? false
      : !areObjectsEqual(this.state.filters, defaultFilter);
  };
  onExpand = (itemId) => {
    if (!this.state.expanded.includes(itemId)) {
      let newExpanded = this.state.expanded;
      newExpanded.push(itemId);
      this.setState({ expanded: newExpanded });
    }
  };
  onCollapse = (itemId) => {
    if (this.state.expanded.includes(itemId)) {
      let newExpanded = this.state.expanded.filter((i) => i !== itemId);
      this.setState({ expanded: newExpanded });
    }
  };
  getCollapse = (itemId) => {
    return <>{this.props.collapsibleSection(itemId)}</>;
  };
  render() {
    const { theme, classes, t } = this.props;
    return (
      <div className={classes.container}>
        {this.state.length === 0 ? (
          <div>{this.props.emptyMessage}</div>
        ) : (
          <>
            <div className={classes.toolBar}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="search-for-teams-input"
                  className={classes.textField}
                  onChange={(e) =>
                    this.setState({ filter: e.target.value }, () =>
                      this.getData()
                    )
                  }
                  value={this.state.filter}
                  InputProps={{
                    startAdornment: <SearchIcon />,
                    endAdornment: (
                      <IconButton
                        onClick={(e) =>
                          this.setState({ filter: "" }, () => this.getData())
                        }
                      >
                        <Tooltip title={t("global_clear")}>
                          <ClearIcon />
                        </Tooltip>
                      </IconButton>
                    ),
                  }}
                />
              </FormControl>
            </div>
            <div className={classes.toolBar}>
              {this.props.filterElement && (
                <FormControl className={classes.formControl}>
                  <Button onClick={this.showFilters}>
                    <Tooltip title={t("global_filter")}>
                      <FilterListIcon />
                    </Tooltip>
                  </Button>
                </FormControl>
              )}
              <FormControl className={classes.formControl}>
                <Button onClick={this.handleSort}>
                  <Tooltip
                    title={
                      this.state.sort === "ASC"
                        ? t("global_ascending")
                        : t("global_descending")
                    }
                  >
                    <svg height="24px" width="24px">
                      <path
                        fill={this.props.iconColour}
                        d={
                          this.state.sort === "ASC"
                            ? this.state.sortAscSVG
                            : this.state.sortDescSVG
                        }
                      />
                    </svg>
                  </Tooltip>
                </Button>
              </FormControl>
              {this.props.addItem && (
                <FormControl className={classes.formControl}>
                  <Button
                    id="filterable-list-add-button"
                    onClick={(e) => {
                      this.props.addItem(e);
                    }}
                    disabled={this.props.addDisabled}
                  >
                    <Tooltip title={t("global_add")}>
                      <AddIcon />
                    </Tooltip>
                  </Button>
                </FormControl>
              )}
            </div>
            <div className={classes.toggleContainer}>
              {this.props.filterElement &&
                this.state.showFilters && (
                  <div className={classes.paginator}>
                    <FilterWrapper
                      asPopper={this.state.asPopper === false ? false : true}
                      open={this.state.showFilters}
                      onClose={this.hideFilters}
                      anchorEl={this.state.anchorEl}
                      filterElement={this.props.filterElement}
                      filter={this.state.filters}
                      onFilterChange={this.onFilterChange}
                      isFilterBar={false}
                      title={this.state.filterTitle}
                      showReset={this.showFilterReset}
                      resetToDefaultFilters={this.resetToDefaultFilters}
                      filterInstance={this.state.filterInstance}
                    />
                  </div>
                )}
              <div className={classes.pgContainer}>
                <Pagination
                  className={classes.paginator}
                  size="small"
                  showFirstButton={true}
                  showLastButton={true}
                  count={this.state.pages}
                  page={this.state.page}
                  onChange={this.handlePageChange}
                  siblingCount={0}
                  boundaryCount={1}
                  color="primary"
                />
              </div>
            </div>
            <List>
              {this.state.data &&
                this.state.data.map((item, idx) => {
                  let itemId = item.hasOwnProperty("taxonomyId")
                    ? item["taxonomyId"]
                    : item.hasOwnProperty("teamId")
                      ? item["teamId"]
                      : item.hasOwnProperty("topicId")
                        ? item["topicId"]
                        : item.hasOwnProperty("organizationId")
                          ? item["organizationId"]
                          : item.hasOwnProperty("userId")
                            ? item["userId"]
                            : -1;
                  let itemType = item.hasOwnProperty("taxonomyId")
                    ? "taxonomy"
                    : item.hasOwnProperty("teamId")
                      ? "team"
                      : item.hasOwnProperty("topicId")
                        ? "topic"
                        : item.hasOwnProperty("organizationId")
                          ? "organization"
                          : item.hasOwnProperty("userId")
                            ? "user"
                            : "";
                  let dValue =
                    '{"id":"' +
                    itemId +
                    '","type":"' +
                    itemType +
                    '", "name":"' +
                    item[this.props.name] +
                    '","icon":"' +
                    this.props.iconSVG +
                    '"}';
                  return (
                    <>
                      <ListItem
                        key={idx}
                        button={true}
                        component="div"
                        onClick={() => this.onClick(item)}
                        selected={this.state.selectedItem === item}
                        draggable={true}
                        onDragStart={this.props.dragStart}
                        onDragEnd={this.props.dragEnd}
                        d={dValue}
                      >
                        <Tooltip
                          title={
                            <Typography>
                              {this.props.iconTooltip
                                ? this.props.iconTooltip(item)
                                : ""}
                            </Typography>
                          }
                          classes={{ popper: classes.tooltip }}
                        >
                          <ListItemAvatar className={classes.avatar}>
                            <svg height="24px" width="24px">
                              <path
                                fill={
                                  this.props.hasOwnProperty("isItemEnabled")
                                    ? this.props.isItemEnabled(item)
                                      ? this.props.iconColour
                                      : this.props.hasOwnProperty(
                                          "iconColourDisabled"
                                        )
                                        ? this.props.iconColourDisabled
                                        : this.props.iconColour
                                    : this.props.iconColour
                                }
                                d={
                                  this.props.hasOwnProperty("disabledIconSVG")
                                    ? !this.props.isItemEnabled(item)
                                      ? this.props.disabledIconSVG
                                      : this.props.iconSVG
                                    : this.props.iconSVG
                                }
                              />
                            </svg>
                          </ListItemAvatar>
                        </Tooltip>
                        <ListItemText
                          secondaryTypographyProps={{ noWrap: true }}
                          primary={
                            this.props.getPrimaryInfo
                              ? this.props.getPrimaryInfo(item)
                              : item[this.props.name]
                          }
                          secondary={
                            this.props.getSecondaryInfo
                              ? this.props.getSecondaryInfo(item)
                              : ""
                          }
                        />

                        {this.state.selectedItem === item &&
                          this.props.editItem && (
                            <ListItemSecondaryAction>
                              <IconButton
                                size="small"
                                onClick={this.props.editItem}
                              >
                                <EditIcon />
                              </IconButton>
                            </ListItemSecondaryAction>
                          )}
                        {this.props.collapsibleSection && (
                          <IconButton>
                            {!this.state.expanded.includes(itemId) ? (
                              <ExpandMoreIcon
                                onClick={() => this.onExpand(itemId)}
                              />
                            ) : (
                              <ExpandLessIcon
                                onClick={() => this.onCollapse(itemId)}
                              />
                            )}
                          </IconButton>
                        )}
                      </ListItem>
                      {this.props.collapsibleSection &&
                        this.state.expanded.includes(itemId) && (
                          <Collapse
                            in={this.state.expanded.includes(itemId)}
                            timeout="auto"
                            unmountOnExit
                          >
                            {this.getCollapse(item)}
                          </Collapse>
                        )}
                    </>
                  );
                })}
            </List>
          </>
        )}
      </div>
    );
  }
  getFilterSettings = () => {
    let filters = "";
    Object.keys(this.state.filters).map((key) => {
      filters += "&" + key + "=" + this.state.filters[key];
    });
    return filters;
  };
  getData = () => {
    let pageNo = this.state.page - 1;
    if (this.props.dataProvider) {
      //parent element provides data directly
      let res = this.props.dataProvider(pageNo,this.state.pageSize,this.state.filter,this.props.name,this.state.sort )
      if (res.data) {
        this.setState({
          data: res.data.content,
          pages: res.data.totalPages,
        });
      }
    } else {
      let url = this.state.filter
      ? this.props.dataurl +
        "?search=" +
        escape(this.state.filter) +
        "&size=" +
        this.state.pageSize +
        "&page=" +
        pageNo +
        "&sort=" +
        this.props.name +
        "," +
        this.state.sort
      : this.props.dataurl +
        "?size=" +
        this.state.pageSize +
        "&page=" +
        pageNo +
        "&sort=" +
        this.props.name +
        "," +
        this.state.sort;

    url +=
      typeof this.state.filters === "object" ? this.getFilterSettings() : "";

    url += this.props.organization
      ? "&orgId=" + escape(this.props.organization.organizationId)
      : "";
    let myAxiosClient =
      url.indexOf("knowledgesource") > -1 ? axios : taxServiceClient;

    myAxiosClient
      .get(url)
      .then((res) => {
        this.setState({
          data: res.data.content,
          pages: res.data.totalPages,
        });
        this.props.onUpdate && this.props.onUpdate(res.data.totalElements);
      })
      .catch((err) => {
        // alert("error");
      });
    }
  };
  onClick = (selectedItem) => {
    this.setState({ selectedItem: selectedItem }, () => {
      this.props.onItemSelected(selectedItem);
    });
  };
  handlePageChange(e, page) {
    this.setState({ page: page }, () => {
      this.getData();
    });
  }
  handleFilter = () => {
    this.getData();
  };
  handleSort = () => {
    this.state.sort === "ASC"
      ? this.setState({ sort: "DESC" }, () => {
          this.getData();
        })
      : this.setState({ sort: "ASC" }, () => {
          this.getData();
        });
  };
}
export default withStyles(styles)(withTranslation()(FilterableList));
